import Box from "@mui/material/Box";

const BroadcastAppGuide = () => {
  return (
    <>
      <Box sx={{ width: "100%", height: "100vh" }}>
        <iframe src="/app_guide/app_guide.html" width="100%" height="100%" style={{ border: 0 }} />
      </Box>
    </>
  );
};

export default BroadcastAppGuide;
